
import React, { Component } from 'react';

import UrlServer from "configs/UrlServer"
import { APIPost, APIGet } from "services/APIRequest"
import * as Alert from "alertService"
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"

//Component==================
import Chart1 from "./chart1"
import Chart2 from "./chart2"

class Chart extends Component {
	constructor() {
		super();
		this.state = {
			quarter: "2",
			data_year: "2021",
			max_in_quarter: null,
			total_invitation_sent: null,
			total_online_success: null,
			total_tele_success: null
		}
	}
	componentDidMount() {
		// URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD1
		Alert.Loading(true)
		const dataToSend = {
			quarter: this.state.quarter,
			data_year: this.state.data_year,
		}
		APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD1, dataToSend, ({ datas }) => {
			Alert.LoadingClose()
			this.setState({
				max_in_quarter: datas.max_in_quarter,
				total_invitation_sent: datas.total_invitation_sent,
				total_online_success: datas.total_online_success,
				total_tele_success: datas.total_tele_success,
			})
		})
	}
	render() {
		return (
			<div className={"card-space"}>
				<hr className="hr-s-m-0" />
				<GridContainer justify="center">
					<GridItem xs={12}>
						<center>
							<h3><b>Survey Progression</b></h3>
						</center>
					</GridItem>
					<GridItem xs={12} sm={6}>
						{
							this.state.max_in_quarter ?
								<Chart1
									quarter={this.state.quarter}
									data_year={this.state.data_year}
									max_in_quarter={this.state.max_in_quarter}
									total_invitation_sent={this.state.total_invitation_sent}
									total_online_success={this.state.total_online_success}
									total_tele_success={this.state.total_tele_success || 0}
								/>
								: null
						}

					</GridItem>
					<GridItem xs={12} sm={6}>
						{
							this.state.max_in_quarter ?
								<Chart2
									max_in_quarter={this.state.max_in_quarter}
									total_invitation_sent={this.state.total_invitation_sent}
									total_online_success={this.state.total_online_success}
									total_tele_success={this.state.total_tele_success || 0}
								/>
								: null
						}
					</GridItem>
				</GridContainer>
			</div>
		);
	}
}

export default Chart;